import { driver } from "driver.js";

export const TutorialDriver = ({ steps }) => {
  // Asegúrate de que steps sea un array válido
  if (!Array.isArray(steps) || steps.length === 0) {
    console.error("TutorialDriver: steps debe ser un array no vacío");
    return null;
  }

  try {
    const driverObj = driver({
      animate: true,
      showProgress: true,
      showButtons: ["next", "previous", "close"],
      nextBtnText: "Siguiente",
      prevBtnText: "Anterior",
      doneBtnText: "Terminar",
      steps: steps,
      overlayClickNext: false, // Prevenir clicks accidentales
      overlayOpacity: 0.5,     // Hacer el overlay más visible
      allowClose: true,        // Permitir cerrar con Escape
      stagePadding: 10,        // Añadir padding al elemento resaltado
    });

    return driverObj;
  } catch (error) {
    console.error("Error al crear el driver:", error);
    return null;
  }
};